// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__cn8GR","prompt":"styles_prompt__b1zKO","title":"styles_title__ZOnrt","description":"styles_description__-DvOU","accent":"styles_accent__BA7L0"};